module.exports = __webpack_public_path__ + "static/progressive-vue-8008bca40f643a51b3aeb1703fca3d5b.png";